// extracted by mini-css-extract-plugin
export default {"container":"JobIdFilter_container__kq2cG"};